import PropTypes from 'prop-types'

const Globe2 = ({
  width = '16',
  height = '16',
  color = 'currentColor',
  className = '',
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill={color}
    className={`bi bi-globe2 ${className}`}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8zm7.5-6.923c-.67.204-1.335.82-1.887 1.855-.28.53-.488 1.15-.6 1.868H7.5V1.077zM4.847 5H2.301a7 7 0 0 0-.478 2.5H4.5a12.5 12.5 0 0 1 .347-2.5zm0 1H7.5V5H4.847a11.5 11.5 0 0 0-.338 2.5H7.5V6.5zm0 2H4.5A12.5 12.5 0 0 1 4.153 11H7.5V8.5H4.51a11.47 11.47 0 0 1-.338 2.5zm-2.546 3.5a7 7 0 0 0 1.79 1.986 11.5 11.5 0 0 1-.786-1.986H2.3zm9.4 0h-1.004a11.5 11.5 0 0 1-.786 1.986A7 7 0 0 0 13.7 12h-1.999zM8.5 1.077c.67.204 1.335.82 1.887 1.855.28.53.488 1.15.6 1.868H8.5V1.077zm0 4.423h2.653c.187.765.306 1.608.338 2.5H8.5V5zm0 2.5v2.5h2.99a12.5 12.5 0 0 0 .338-2.5H8.5zm0 3.5v2.923c.67-.204 1.335-.82 1.887-1.855.28-.53.488-1.15.6-1.868H8.5zm3.153-1H13.7a7 7 0 0 0 .478-2.5H11.5c-.033.892-.152 1.735-.338 2.5zm.338-3.5c-.033-.892-.152-1.735-.338-2.5H11.7a7 7 0 0 0-.478 2.5h2.199zm-2.199-3.5H11.7a7 7 0 0 0-1.79-1.986 11.5 11.5 0 0 1 .786 1.986zM2.3 4h1.999A11.5 11.5 0 0 1 5.085 2.014 7 7 0 0 0 2.3 4z" />
  </svg>
)

Globe2.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  color: PropTypes.string,
  className: PropTypes.string,
}

export default Globe2
